import Relay from 'react-relay';
/**
*  Update lightGroup mutation
*/
export default class UpdateLightGroupMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation Mutation{
      updateLightGroup
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
        lightGroupId: this.props.lightGroupId,
        lightGroup: {
            ...this.props.lightGroup
        }
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on updateLightGroupPayload @relay(pattern: true){
        clientMutationId,
        viewer{
            id
        }
        lightGroup {
            id, 
            name,
            description, 
            status,
            accessMinutes {
                before,
                after
            }
            allowUserAccess
            infrastructures {
                id
            }
            externalId
        }
      }
    `;
  }

  /**
  *  Config
  */
  getConfigs() {
    return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          viewer: this.props.viewer.id,
        },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
          id
      }
    `,
  };
}



// WEBPACK FOOTER //
// ./src/mutations/Venue/UpdateLightGroupMutation.js